import { computed, Ref, unref } from "vue";
import { useStore } from "vuex";
import { useContact } from "@/composables/contacts/useContact";

export function useTaskFollowupContact(selectedBucket: Ref<any>) {
  const store = useStore();
  const account = computed(() => store.getters.account.data);

  const contactParams = computed(() => {
    const bucket = unref(selectedBucket);
    if (!bucket?.contactId || !account.value?.organizationId) return null;
    return { id: bucket.contactId, organizationId: account.value.organizationId };
  });

  const { data: contactQueryData, isLoading } = useContact(contactParams);

  // Take [0] from array response; fall back to selectedBucket.contact before query resolves
  const contact = computed(() => {
    const fromQuery = contactQueryData.value;
    if (Array.isArray(fromQuery) && fromQuery.length > 0) return fromQuery[0];
    if (fromQuery && !Array.isArray(fromQuery)) return fromQuery;
    return unref(selectedBucket)?.contact ?? null;
  });

  return { contact, isLoading };
}
